import { CheckIcon } from "@heroicons/react/outline";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExclamationIcon } from "@heroicons/react/solid";
import RequestAppointmentResignation from "../modal/RequestAppointmentResignation";
import RequestsModel from "../../api/models/RequestsModel";
import moment from "moment";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
type OutGoingRequestCardCardProps = {
  request?: RequestsModel | null;
};
export default function OutGoingRequestAppointmentCard(
  props: OutGoingRequestCardCardProps
) {
  const { request } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [open, setOpen] = useState<boolean>(false);
  const { currentUser, userType }: any = useAuth();
  const navigate = useNavigate();

  const renderStatus = useMemo(() => {
    if (request?.status === "rejected")
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-red-600 bg-transparent border border-red-600 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("haveRejected")}
        </span>
      );
    if (request?.status === "approved")
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-green-500 bg-transparent border border-green-500 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("haveAccepted")}
        </span>
      );
    else
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-yellow-600 bg-transparent border border-yellow-600 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("havePending")}
        </span>
      );
  }, [request]);
  return (
    <>
      <div className="flex flex-col gap-2 pb-4 border-b border-gray-200">
        <div className="flex items-center justify-end w-full">
          <p className="text-sm text-gray-400">
            {" "}
            {moment(request?.createdAt).fromNow(true)}
          </p>
        </div>
        <div className="flex flex-col justify-between w-full gap-3 sm:gap-0 sm:flex-row">
          <div className="relative flex items-center gap-1 space-x-3">
            <div className="flex-shrink-0">
              <UserProfilePictureAvatar
                profilePictureUrl={request?.user?.profile_picture_url}
                className="w-10 h-10"
                alt="avatar"
              />
            </div>
            <div className="flex-1 min-w-0">
              <a className="focus:outline-none">
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-lg font-semibold text-gray-500">
                  {request?.user?.fullNameWithoutMiddle}
                </p>
              </a>
            </div>
          </div>
          <div className="flex flex-row items-center gap-3">
            {(!!currentUser?.hasRecitationSchedule ||
              userType !== "student" ||
              request?.status === "pending") && (
              <button
                onClick={() => setOpen(true)}
                className="text-sm font-medium underline text-brandblue-600 "
              >
                {t("showRequest")}
              </button>
            )}

            {!currentUser?.hasRecitationSchedule &&
              userType === "student" &&
              request?.status === "rejected" && (
                <button
                  onClick={() => navigate("/student/proposed-schedule")}
                  className="text-sm font-medium underline text-brandblue-600 "
                >
                  {t("setCalendar")}
                </button>
              )}
            {renderStatus}
          </div>
        </div>
      </div>
      <RequestAppointmentResignation
        open={open}
        setOpen={(newValue: boolean) => setOpen(false)}
        request={request}
        owner={false}
      />
    </>
  );
}
